import { getFirebaseClientAuth } from "@/lib/firebase-client-config";

export interface Res<T> {
    isOk: boolean;
    response?: T;
    error?: unknown;
    statusCode: number;
}

// Attacca l'Authorization: Bearer <idToken> se withCredentials
const adjustHeader = async (
    withCredentials: boolean,
    header1: Record<string, string>,
    header2: Record<string, string>,
) => {
    const extra: Record<string, string> = {};
    if (withCredentials) {
        const firebaseClientAuth = await getFirebaseClientAuth();
        if (!firebaseClientAuth) {
            console.error("firebaseClientAuth is null");
            throw new Error("firebaseClientAuth is null");
        }
        const jwt = await firebaseClientAuth.currentUser?.getIdToken();
        if (jwt) {
            extra["Authorization"] = "Bearer " + jwt;
        }
    }
    return { ...header1, ...header2, ...extra };
};

export async function createResFromResponse<T>(res: Response): Promise<Res<T>> {
    let body = null;
    try {
        body = await res.json();
    } catch (e) {
        console.error("Error createResFromResponse", e);
    }
    return {
        statusCode: res.status,
        isOk: res.ok,
        response: res.ok ? (body as T) : undefined,
        error: !res.ok ? body : null,
    };
}

export function createExceptionRes(exception: unknown): Res<never> {
    return {
        statusCode: 500,
        isOk: false,
        response: undefined,
        error: exception,
    };
}

function withQuery(url: string, data: Record<string, unknown> = {}): string {
    const params = new URLSearchParams();
    Object.entries(data ?? {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null) params.append(k, String(v));
    });
    const qs = params.toString();
    return qs ? `${url}${url.includes("?") ? "&" : "?"}${qs}` : url;
}

export async function commonGetData(
    withCredential: boolean,
    headers: Record<string, string> = {},
    url = "",
    data: Record<string, unknown> = {},
) {
    return await fetch(withQuery(url, data), {
        method: "GET",
        cache: "no-cache",
        headers: await adjustHeader(withCredential, headers, {
            "Content-Type": "application/json",
        }),
    });
}

export async function commonPostData(
    withCredential: boolean,
    headers: Record<string, string> = {},
    url = "",
    data: unknown = {},
) {
    return await fetch(url, {
        method: "POST",
        cache: "no-cache",
        headers: await adjustHeader(withCredential, headers, {
            "Content-Type": "application/json",
        }),
        body: JSON.stringify(data),
    });
}
